exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-tab table tr:first-child th {\n  text-align: left; }\n  .help-tab table tr:first-child th:nth-child(1) {\n    width: 10em; }\n  .help-tab table tr:first-child th:nth-child(2) {\n    width: 5em; }\n  .help-tab table tr:first-child th:nth-child(3) {\n    padding-left: 0.5em; }\n\n.help-tab table tr:not(first-child) td:nth-child(1) {\n  font-family: monospace; }\n\n.help-tab table tr:not(first-child) td:nth-child(2) {\n  color: #007AA2;\n  font-style: italic;\n  cursor: help; }\n\n.help-tab img {\n  display: block;\n  margin: 0 auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/gui/tabs/help/help.scss
// module id = 173
// module chunks = 0